module.exports = __webpack_public_path__ + "static/media/Safe-T8.9323afaf.jpg";